import React, { } from 'react';
import { useStateContext } from '../../../../contexts/ContextProvider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import ViewCustomerComments from '../ViewCustomerComments/ViewCustomerComments';
import CustomerCommentsImagesCarousel from './CustomerCommentsImagesCarousel';
import UpdateCustomerComments from '../UpdateCustomerComments';

const CustomerCommentsCards = ({ fromHome, usrDbRoles }) => {
  const { customerComments, convertUtcToLocal, formatDateToItalian, trimHTML } = useStateContext();

  return (
    <>
      {fromHome && <h4>Dicono a noi:</h4>}
      {customerComments && customerComments.length > 0 ? (
        <Grid container spacing={2}>
          {customerComments.map((comment) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={comment.id}>
              <Card className='shadowClass'>
                {/* CAROUSEL WITH ONLY IMAGE */}
                {comment.attachments.length > 0 && (
                  <CustomerCommentsImagesCarousel attachments={comment.attachments} />
                )}
                {/* CARD CONTENT */}
                <CardContent style={{ textAlign: 'center' }}>
                  <h5><b>{comment.title}</b></h5>
                  <p>{formatDateToItalian(convertUtcToLocal(comment.publish_date))}</p>
                  <hr />
                  {/* COMMENT BODY */}
                  <div dangerouslySetInnerHTML={{ __html: trimHTML(comment.body, 35) }} />
                  <br />
                  <ViewCustomerComments comment={comment} />
                  {!fromHome && usrDbRoles.includes('PUB') && <UpdateCustomerComments oldComment={comment}/>}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <p>Nessun commento cliente trovato ...</p>
      )}
    </>
  );
};

export default CustomerCommentsCards;